import { QUERY_KEYS } from '../../../../../consts';
import { getPatientDealsService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const getPatientDealsAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.PATIENT_DEALS,
  mutationFn: () => getPatientDealsService,
});
